// extracted by mini-css-extract-plugin
module.exports = {"root":"_3PptWoQJXdJS","control":"p6Ziw_4Cyaea","control__edit":"_3FBPP6r7xVjd","price":"_25vRrMAQfgie","price__selected":"_2eqQHW1v9Fd1"};